import { trackBuilderTestEntered } from '../actions';

export function shouldTrackBuilderTestContent(content) {
  return content?.testRatio > 0 && content?.testRatio < 1;
}

export function trackBuilderTest(dispatch, content) {
  if (shouldTrackBuilderTestContent(content)) {
    dispatch(
      trackBuilderTestEntered({
        ...content,
      })
    );
  }
}
